import { render, staticRenderFns } from "./TwBlDetailInner.vue?vue&type=template&id=7ffbd9c6&scoped=true&"
import script from "./TwBlDetailInner.vue?vue&type=script&lang=js&"
export * from "./TwBlDetailInner.vue?vue&type=script&lang=js&"
import style0 from "./TwBlDetailInner.vue?vue&type=style&index=0&id=7ffbd9c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffbd9c6",
  null
  
)

export default component.exports